import { devLogger } from "@/utils/dev-logger.util";
/**
 * Creates HTML for article skeleton loaders
 * @param options Configuration options for the skeleton
 * @returns HTML string containing skeleton loaders
 */
export function createArticleSkeleton(options = {}) {
    const { count = 4, wrapperClass = "swiper-slide", slideClass = "", } = options;
    const skeletons = [];
    for (let i = 0; i < count; i++) {
        const skeletonItem = [
            `<div class="article-skeleton ${wrapperClass} ${slideClass}">`,
            '<div class="article-card-skeleton group relative rounded-lg overflow-hidden shadow-md h-full">',
            '<div class="article-card-image-wrapper relative h-105 lg:h-100">',
            '<div class="skeleton-image absolute inset-0 w-full h-full"></div>',
            '<div class="md:block hidden absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent"></div>',
            '<div class="md:hidden block absolute inset-0 bg-black/50 z-10 w-full h-full"></div>',
            '<div class="md:hidden block absolute inset-0 backdrop-blur-[6px] z-11" style="mask-image:linear-gradient(to_top,rgba(0,0,0,1)_0%,rgba(0,0,0,1)_51%,rgba(0,0,0,0)_64%)"></div>',
            '<div class="relative h-full flex flex-col justify-between p-6 md:p-8 z-12">',
            '<div class="self-start">',
            '<div class="skeleton-badge h-6 w-24 rounded-md"></div>',
            '</div>',
            '<div class="space-y-4 md:pr-0 pr-6">',
            '<div class="skeleton-title h-7 w-full rounded-md"></div>',
            '<div class="skeleton-title h-7 w-4/5 rounded-md"></div>',
            '<div class="skeleton-description h-4 w-full rounded-md"></div>',
            '<div class="skeleton-description h-4 w-5/6 rounded-md"></div>',
            '<div class="article-card-date-time flex items-center justify-between mt-4">',
            '<div class="skeleton-date h-4 w-32 rounded-md"></div>',
            '<div class="md:block hidden skeleton-cta w-10 h-10 rounded-full"></div>',
            '</div>',
            '<div class="md:hidden block skeleton-learn-more h-5 w-24 rounded-md"></div>',
            '</div>',
            '</div>',
            '</div>',
            '</div>',
            '</div>'
        ].join('');
        skeletons.push(skeletonItem);
    }
    return skeletons.join("");
}
/**
 * Renders article skeleton loaders into a target element
 * @param targetElement The element to render skeletons into
 * @param options Configuration options for the skeleton
 */
export function renderArticleSkeleton(targetElement, options = {}) {
    if (!targetElement) {
        devLogger.warn("[ArticleSkeleton] Target element not found");
        return;
    }
    const skeletonHTML = createArticleSkeleton(options);
    if (skeletonHTML) {
        targetElement.innerHTML = skeletonHTML;
    }
    else {
        devLogger.warn("[ArticleSkeleton] Failed to create skeleton HTML");
    }
}
